"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_PART_DIRECTORY_ORIGIN = void 0;
exports.readPagePartDirectory = readPagePartDirectory;
exports.planPagePartDirectoryChanges = planPagePartDirectoryChanges;
exports.applyPagePartDirectoryChanges = applyPagePartDirectoryChanges;
const database_bytes_text_1 = require("./database-bytes-text");
const page_document_maps_1 = require("./page-document-maps");
const page_part_summary_1 = require("./page-part-summary");
exports.PAGE_PART_DIRECTORY_ORIGIN = Symbol('page-part-directory');
const DIRECTORY_KEY = 'pageParts';
function copyEntry(value) {
    if (!Number.isSafeInteger(value.b) || value.b < 0)
        throw new Error('Invalid page part byte size');
    if (value.r !== undefined &&
        (!Array.isArray(value.r) ||
            value.r.length !== 4 ||
            !value.r.every(Number.isFinite) ||
            value.r[2] < 0 ||
            value.r[3] < 0))
        throw new Error('Invalid page part rectangle');
    return {
        b: value.b,
        ...(value.m === undefined ? {} : { m: (0, page_part_summary_1.readPagePartSummary)(value.m) }),
        ...(value.r === undefined
            ? {}
            : { r: [...value.r] }),
    };
}
function storedEntry(value) {
    if (value.m?.ids === undefined)
        return value;
    const { ids, ...summary } = value.m;
    return { ...value, m: { ...summary, ids: (0, database_bytes_text_1.encodeDatabaseBytesText)(ids) } };
}
function entryOfStored(value) {
    const ids = value.m?.ids;
    if (ids === undefined)
        return copyEntry(value);
    if (!(0, database_bytes_text_1.isDatabaseBytesText)(ids))
        throw new Error('Invalid page part summary ids');
    return copyEntry({
        ...value,
        m: { ...value.m, ids: (0, database_bytes_text_1.decodeDatabaseBytesText)(ids) },
    });
}
function readPagePartDirectory(doc) {
    return new Map([...doc.getMap(DIRECTORY_KEY)].map(([id, value]) => [id, entryOfStored(value)]));
}
/** Observations are partial: unobserved parts remain untouched, including small parts. */
function planPagePartDirectoryChanges(current, observed) {
    const changes = [];
    for (const [partId, observedValue] of observed) {
        const value = copyEntry(observedValue);
        if (value.b === 0) {
            if (current.has(partId))
                changes.push({ kind: 'remove', partId });
            continue;
        }
        const previous = current.get(partId);
        if (previous?.b !== value.b ||
            JSON.stringify(previous.r) !== JSON.stringify(value.r) ||
            (previous.m === undefined || value.m === undefined
                ? previous.m !== value.m
                : !(0, page_part_summary_1.samePagePartSummary)(previous.m, value.m)))
            changes.push({ kind: 'set', partId, value });
    }
    return changes;
}
/** Rechecks structure at apply time, including retained deleted entries. */
function applyPagePartDirectoryChanges(doc, changes, partStructures = new Map([
    [page_document_maps_1.PAGE_DOCUMENT_PART_ID, (0, page_document_maps_1.pageStructureMap)(doc)],
])) {
    const prepared = changes.map(change => change.kind === 'set'
        ? { ...change, value: copyEntry(change.value) }
        : change);
    const referenced = new Set();
    if (prepared.some(change => change.kind === 'remove'))
        for (const [partId, structure] of partStructures)
            if (structure.size > 0)
                referenced.add(partId);
    doc.transact(() => {
        const directory = doc.getMap(DIRECTORY_KEY);
        for (const change of prepared) {
            if (change.kind === 'set')
                directory.set(change.partId, storedEntry(change.value));
            else if (!referenced.has(change.partId))
                directory.delete(change.partId);
        }
    }, exports.PAGE_PART_DIRECTORY_ORIGIN);
}
